import { useMemo, } from 'react';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  CommercialTable,
} from '../../../common/Tables/Tables.jsx';
import {
  commercialTableHeader,
} from '../../../../assets/helpers/tables.js';
import {
  itemsPerPageOptions,
} from '../parametersConstants.js';
import CommercialForm from './CommercialForm.jsx';
import useSalesChannels from '../../../../hooks/params/useSalesChannels.jsx';
import { SearchInput } from '../../../common/Forms/Input/Input.jsx';

export const CommercialParametersSection = () => {

  const {
    register,
    errors,
    showSalesChannelForm,
    commercialSubTab,
    setCommercialSubTab,
    handleSalesChannelsPageChange,
    handleToggleSalesChannelActive,
    handleEditSalesChannel,
    onSalesChannelSelectPerPage,
    onSubmit,
    inactiveSalesChannels,
    setShowSalesChannelForm,
    editingSalesChannelId,
    salesChannelData,
    closeForm,
    searchInputValue,
    setSearchInputValue,
    handleChannelIdsFilter,
    channelOptions,
  } = useSalesChannels();

  const commercialHeaderWithFilter = useMemo(
    () =>
      commercialTableHeader.map((h) =>
        h?.value === 'name'
          ? {
            ...h,
            sortable: true,
            filterOptions: channelOptions,
            filterSearch: handleChannelIdsFilter,
          }
          : h
      ),
    [channelOptions, handleChannelIdsFilter]
  );

  return (
    <>
      <div className="parameters-page__pills-row">
        <div className="parameters-page__pills">
          <ActionButton
            type="button"
            action={() => setCommercialSubTab('channels')}
            label="Canales"
          />
        </div>
        <ActionButton
          type="button"
          action={() => setShowSalesChannelForm((s) => !s)}
          label={'+ Crear canal de venta'}
        />
      </div>
      <div className="parameters-page__table-toolbar">
        <SearchInput
          placeholder="Buscar por nombre del canal de venta"
          width="100%"
          value={searchInputValue}
          onChange={(e) => setSearchInputValue(e.target.value)}
          searchAction={() => { }}
        />
      </div>

      {showSalesChannelForm && (
        <CommercialForm
          register={register}
          errors={errors}
          editingSalesChannelId={editingSalesChannelId}
          onSubmit={onSubmit}
          closeForm={closeForm}
        />
      )}

      {commercialSubTab === 'channels' && (
        <CommercialTable
          header={commercialHeaderWithFilter}
          data={salesChannelData}
          handlePageChange={handleSalesChannelsPageChange}
          onToggleActive={handleToggleSalesChannelActive}
          onEdit={handleEditSalesChannel}
          itemsPerPageOptions={itemsPerPageOptions}
          onPerPageChange={onSalesChannelSelectPerPage}
          inactiveCount={inactiveSalesChannels}
        />
      )}
    </>
  );
};
